import rg4js from 'raygun4js'

rg4js('apiKey', process.env.RAYGUN_API_KEY)
rg4js('enableCrashReporting', true)
rg4js('setUser', {
  identifier: localStorage.getItem('email'),
  isAnonymous: false,
  email: localStorage.getItem('email'),
  firstName: localStorage.getItem('name'),
  fullName: localStorage.getItem('family_name')
})

export default {
  send: (error) => {
    if (process.env.NODE_ENV === 'production') {
      rg4js('send', error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/Raygun.js